"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractsSearchParamsCreator = void 0;
const types_1 = require("@framework/types");
const types_2 = require("../types");
const contractStatus = [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW];
const contractsSearchParamsCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        contractStatus,
        contractFeatures: [],
    },
    [types_2.ServiceType.OFFICE]: {
        contractStatus,
        contractFeatures: [],
        merchantId: profile.merchantId,
    },
});
exports.contractsSearchParamsCreator = contractsSearchParamsCreator;
//# sourceMappingURL=contracts-search-params.js.map